module.exports = __webpack_public_path__ + "static/media/cat-lady4.2a897848.png";